import { ACTION_TYPE } from '../../store/actionCreatorsHelpers';

export function hideNotification() {
    return {
        type: ACTION_TYPE.HIDE_NOTIFICATION,
    };
}

export function destroyNotification() {
    return {
        type: ACTION_TYPE.DESTROY_NOTIFICATION,
    };
}
